import Cookies from 'js-cookie'

const userData = JSON.parse(localStorage.getItem('userData'))

export const currentUser = userData
export const token = Cookies.get('affiliate_app_token')
export default null
